// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type * as React from "react";

/**
 * File icon with a circular "refresh" arrow loop inside, used for the
 * re-trigger import action. Fully Lucide-compatible (accepts all SVG props,
 * inherits currentColor).
 */
export function ImportRetriggerIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M10 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8" />
      <path d="M12 11v4h4" />
      <path d="m12 15 1.535-1.605a5 5 0 0 1 8 1.5" />
      <path d="M15 8a1 1 0 0 1-1-1V2a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8z" />
      <path d="M20 8v1" />
      <path d="m22 19-1.535 1.605a5 5 0 0 1-8-1.5" />
      <path d="M22 23v-4h-4" />
      <path d="M8 13h.01" />
      <path d="M8 17h.01" />
      <path d="M8 9h.01" />
    </svg>
  );
}
